import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { push } from "connected-react-router";
import React from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { portfolioCreationManualCompositionGridId } from "components/modal/portfolio-creation-edit/portfolio-creation-edit-manual-composition/insPortfolioCreationManualCompositionGrid";
import { ModalName } from "components/modal/types";
import { useDeletePortfolios } from "hooks/use-delete-portfolios";
import { language } from "language/default";
import { removeAllEditedRow, removeAllSelectedRow } from "store/grids";
import { closeDialog } from "store/messages-dialog";
import { closeModal } from "store/modal";
import { resetPortfolioCreation } from "store/portfolio-creation";
export const InsDeletePortfolioFromEditButtonDialogAction = () => {
    const dispatch = useDispatch();
    const [, deletePortfoliosMutation] = useDeletePortfolios();
    const PortfolioId = useSelector((state) => state.currentDashboard.currentEntityId);
    const deleteRequest = { deletePortfolioRequest: { portfolioIds: [PortfolioId] } };
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.delete, key: "main-delete-button", type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, onClick: () => {
                batch(() => {
                    deletePortfoliosMutation(deleteRequest, {});
                    dispatch(closeDialog());
                    dispatch(closeModal(ModalName.PortfolioEdition));
                    dispatch(push("/portfolios"));
                    dispatch(resetPortfolioCreation());
                    dispatch(removeAllSelectedRow(portfolioCreationManualCompositionGridId));
                    dispatch(removeAllEditedRow(portfolioCreationManualCompositionGridId));
                });
            } }),
        React.createElement(CloseDialogButton, null));
};
